import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Paging } from '../../../model/paging/paging';
import { Channels } from '../../../model/channel/channel';

@Injectable({
    providedIn: 'root'
})
export class ChannelService_Mock {

    GETPaginatedChannels(paging:Paging): Observable<Channels>  | any{
        const allData = this.getMockChannels();
        const start = (paging.pageIndex - 1) * paging.pageSize;
        const end = start + paging.pageSize;
        const pageData = allData.slice(start, end);
        return of({
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 10,
            data: {
                count: allData.length,
                items: pageData
            }
        });
    }

    GETChannelById(channelId:string): Observable<Channels>  | any{
        const channelDetails = this.getMockChannels().find((item) => item.channelId === channelId) ?? this.getMockChannels()[0];

        return of({
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 8,
            data: {
                frequency: channelDetails?.frequency,
                channel: channelDetails?.channel ?? []
            }
        });
    }

    DELETEChannel(channelId:string){
        return of({
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 7,
            data: true
        });
    }

    POSTChannel(body:Channels){
        return of({
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        });
    }

    PUTChannel(channelId:string, body:Channels){
        return of({
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        });
    }

    private getMockChannels() {
        return [
            {
                channelId: "freq-2-4-ghz",
                frequency: "FREQ_2_4_GHZ",
                channel: [{ channelN: 1 }, { channelN: 6 }, { channelN: 11 }]
            },
            {
                channelId: "freq-5-ghz",
                frequency: "FREQ_5_GHZ",
                channel: [{ channelN: 36 }, { channelN: 40 }, { channelN: 44 }]
            },
            {
                channelId: "freq-6-ghz",
                frequency: "FREQ_6_GHZ",
                channel: [{ channelN: 5 }, { channelN: 21 }, { channelN: 37 }]
            }
        ];
    }
}
